module.exports = __webpack_public_path__ + "static/media/cat-rfv2.dae0a39b.jpg";